module.exports = __webpack_public_path__ + "static/media/tempolibero_logo.71f2a932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tempolibero_logo.png
// module id = 1618
// module chunks = 0